import { apiHolder, apis } from 'api';
import React, { useMemo } from 'react';
import { FLOLDER, TASK_MAIL_STATUS } from '../../../constant';
import { defaultComAvatar, defaultDesc, defaultSender, defaultFromFlagAfter, defaultTaskDeadLine, defaultComTime, defaultCardLongComSummary, defaultComSummaryPreExtra, defaultComSummaryExtra, defaultComStatus, defaultAllTag, defaultSendReadStatus, defaultComSummaryTask, receiverComAvatar, defaultCustomerLabelAfter, defaultApprove, defaultSuborbinateFrom, } from './defaultComs';
import { defaultComAttachmentLong } from './DefaultAttachment';
import './MailCard.scss';
import IconCard from '@web-common/components/UI/IconCard';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import Checkbox from '@lingxi-common-component/sirius-ui/Checkbox';
import ontimeIcon from '@/images/icons/todomail/ontime.svg';
import timeoutIcon from '@/images/icons/todomail/timeout.svg';
import { Tooltip } from 'antd';
import MailCardStateIcon from './MailCardStateIcon';
import { getIn18Text } from 'api';
import moment from 'moment';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { useAppSelector } from '@web-common/state/createStore';
const systemApi = apiHolder.api.getSystemApi();
const productAuthApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const getComponent = (props, DefaultCom, Com) => Com != null ? React.createElement(Com, Object.assign({}, props)) : DefaultCom != null ? React.createElement(DefaultCom, Object.assign({}, props)) : null;
const structHeightMap1 = {
    from: 32,
    summary: 32,
    desc: 32,
    attachments: 28,
    sendStatus: 24,
    readStatus: 24,
    taskDeadline: 20,
    suborbinateSearchFrom: 24,
};
const structHeightMap2 = {
    from: 32,
    summary: 32,
    desc: 32,
    attachments: 28,
    sendStatus: 24,
    readStatus: 24,
    taskDeadline: 20,
    suborbinateSearchFrom: 24,
};
const structHeightMap3 = {
    from: 32,
    summary: 32,
    desc: 32,
    attachments: 24,
    sendStatus: 24,
    readStatus: 24,
    taskDeadline: 20,
    suborbinateSearchFrom: 24,
};
const structHeightMap = [structHeightMap1, structHeightMap2, structHeightMap3];
const getVisibleStructHeight = (data, forceShowAttachment, showSuborbinateFrom) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const isCorpMail = systemApi.getIsCorpMailMode();
    const isFree = productAuthApi.doGetProductVersionId() === 'free';
    const isSirius = productAuthApi.doGetProductVersionId() === 'sirius';
    const isOther = productAuthApi.doGetProductVersionId() !== 'free' && productAuthApi.doGetProductVersionId() !== 'sirius';
    const tightness = mailConfApi.getMailListTightness();
    const dayLimit = mailConfApi.getMailDayLimit();
    const { from, summary, desc, attachments, sendStatus, readStatus, taskDeadline, suborbinateSearchFrom } = structHeightMap[+tightness - 1];
    const res = {
        from,
        summary,
        desc,
    };
    if (data && ((_a = data.entry.attachment) === null || _a === void 0 ? void 0 : _a.length)) {
        let attachment = [];
        attachment = (_b = data.entry.attachment) === null || _b === void 0 ? void 0 : _b.filter(item => item.inlined === false && item.fileType !== 'ics' && item.type !== 'netfolder');
        if (attachment.length) {
            res.attachments = attachments;
        }
    }
    if (!isCorpMail && data && data.entry.sendStatus) {
        res.sendStatus = sendStatus;
    }
    const accountAlias = ((_d = (_c = systemApi.getCurrentUser(data === null || data === void 0 ? void 0 : data._account)) === null || _c === void 0 ? void 0 : _c.prop) === null || _d === void 0 ? void 0 : _d.accountAlias) || [];
    const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
    const senderEmail = ((_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.sender) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.contact) === null || _g === void 0 ? void 0 : _g.accountName) || '';
    const isSend = ((_h = data === null || data === void 0 ? void 0 : data.entry) === null || _h === void 0 ? void 0 : _h.folder) === FLOLDER.SENT ||
        accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) ||
        accountApi.getIsSameSubAccountSync(senderEmail, data._account);
    const dateArr = (_k = (_j = data.entry.sendTime) === null || _j === void 0 ? void 0 : _j.trim()) === null || _k === void 0 ? void 0 : _k.split(/\s+/);
    let isBeforeday = false;
    if (!((_l = data.entry) === null || _l === void 0 ? void 0 : _l.sendTime) || !dateArr || (dateArr === null || dateArr === void 0 ? void 0 : dateArr.length) < 2) {
        isBeforeday = true;
    }
    else {
        const utcStr = dateArr[0] + 'T' + dateArr[1] + '+08:00';
        const sendValue = moment(utcStr);
        if (moment().add(-dayLimit.thirdDayLimit, 'day').isAfter(sendValue, 'day')) {
            isBeforeday = true;
        }
        else {
            isBeforeday = false;
        }
    }
    const showOpenRecord = data.authAccountType && data.authAccountType !== '0' && !isBeforeday && isSirius;
    if (!isCorpMail &&
        !isFree &&
        data &&
        isSend &&
        !data.taskId &&
        ((isSirius && (data.entry.rcptCount || data.entry.readCount)) || (isOther && (data.entry.rcptCount || data.entry.innerRead)) || showOpenRecord)) {
        res.readStatus = readStatus;
    }
    if (!isCorpMail && data && data.taskId && data.taskInfo) {
        res.taskDeadline = taskDeadline;
        res.desc = null;
    }
    const showDesc = mailConfApi.getMailShowDesc();
    const showAttachment = forceShowAttachment || mailConfApi.getMailShowAttachment();
    if (!showDesc) {
        res.desc = null;
    }
    if (!showAttachment) {
        res.attachments = null;
    }
    if (showSuborbinateFrom && !!data.isTpMail && data.mailFrom === 'subordinate' && ((_m = data === null || data === void 0 ? void 0 : data.tpMailInfo) === null || _m === void 0 ? void 0 : _m.subordinateSearch) && ((_o = data.tpMailInfo.receiverSD) === null || _o === void 0 ? void 0 : _o.length)) {
        res.suborbinateSearchFrom = suborbinateSearchFrom;
    }
    return res;
};
const MailCard = props => {
    var _a, _b, _c;
    const { data, active = false, checked = false, className = '', avatar, desc, from, fromFlagAfter, customerLabelAfter, deadLine, time, summary, summaryExtra, attachments, status, tag, summaryPreExtra, sendReadStatus, onChecked, isMultiple, showAvator = true, showCheckbox = false, hoverCheckbox = false, forceShowAttachment = false, width, showSuborbinateFrom = false, } = props;
    const { isThread, isTpMail, entry: { readStatus, eTeamType, attachment, folder, title, brief, isDefer, deferTime, memo }, } = data;
    const key2Heigt = getVisibleStructHeight(data, forceShowAttachment, showSuborbinateFrom);
    const isRead = readStatus === 'read';
    const isDraft = folder === FLOLDER.DRAFT;
    const isSent = folder === FLOLDER.SENT;
    const showRedFlagBg = useAppSelector(state => state.mailReducer.configMailListShowRedFlagBg);
    const isRedFlagMail = ((_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.mark) === 'redFlag';
    const tightness = mailConfApi.getMailListTightness();
    const avatorSize = +tightness === 3 ? 20 : +tightness === 2 ? 28 : 32;
    let comAvatar = getComponent(Object.assign(Object.assign({}, props), { size: avatorSize }), defaultComAvatar, avatar);
    if (isSent && ((_b = data === null || data === void 0 ? void 0 : data.receiver) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        comAvatar = getComponent(Object.assign(Object.assign({}, props), { size: avatorSize }), receiverComAvatar, avatar);
    }
    const comDesc = getComponent(props, defaultDesc, desc);
    const comFrom = getComponent(props, defaultSender, from);
    const comFromFlagAfter = getComponent(props, defaultFromFlagAfter, fromFlagAfter);
    const comCustomerLabelAfter = getComponent(props, defaultCustomerLabelAfter, customerLabelAfter);
    const comTaskDeadLine = getComponent(props, defaultTaskDeadLine, deadLine);
    const comTime = getComponent(props, defaultComTime, time);
    const comSummary = getComponent(props, defaultCardLongComSummary, summary);
    const comSummaryTask = getComponent(props, defaultComSummaryTask, summary);
    const comSummaryExtra = getComponent(props, defaultComSummaryExtra, summaryExtra);
    const comSummaryPreExtra = getComponent(props, defaultComSummaryPreExtra, summaryPreExtra);
    const comAttachments = getComponent(props, defaultComAttachmentLong, attachments);
    const comStatus = getComponent(props, defaultComStatus, status);
    const comApprove = getComponent(props, defaultApprove);
    const comTag = getComponent(props, defaultAllTag, tag);
    const comSendReadStatus = getComponent(props, defaultSendReadStatus, sendReadStatus);
    const comSuborbinateFrom = getComponent(props, defaultSuborbinateFrom);
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const attachmentList = attachment === null || attachment === void 0 ? void 0 : attachment.filter(item => !item.inlined && item.fileType !== 'ics' && item.type !== 'netfolder');
    const showAttachmentIcon = attachmentList && attachmentList.length && !mailConfApi.getMailShowAttachment();
    const isOverdue = useMemo(() => {
        return moment(deferTime, 'YYYY-MM-DD HH:mm:ss').valueOf() < moment().valueOf();
    }, [deferTime]);
    const isSubordinateMail = (data === null || data === void 0 ? void 0 : data.mailFrom) === 'subordinate' && !!(data === null || data === void 0 ? void 0 : data.isTpMail);
    const cardCheckboxDisabled = ((_c = data === null || data === void 0 ? void 0 : data.taskInfo) === null || _c === void 0 ? void 0 : _c.status) === TASK_MAIL_STATUS.PROCESSING;
    const renderLongCard = () => {
        var _a, _b;
        return (React.createElement("div", { className: `mail-list-item mail-list-item-long ${active ? 'active' : ''} ${showRedFlagBg && isRedFlagMail ? 'red-flag-bg' : ''}` },
            React.createElement("div", { className: `avatar-wrap-out ${showCheckbox && hoverCheckbox ? 'avatar-wrap-hover' : ''} ${isMultiple && showCheckbox ? 'avatar-wrap-showbox' : ''}` },
                React.createElement("div", { className: "avatar-wrap" },
                    showCheckbox ? (cardCheckboxDisabled ? (React.createElement(Tooltip, { title: getIn18Text('RENWUYOUJIANBU'), autoAdjustOverflow: true },
                        React.createElement(Checkbox, { style: { marginRight: showAvator ? '7px' : '0px' }, className: "avatar-checkbox", checked: checked, disabled: true, onClick: e => {
                                e.stopPropagation();
                                try {
                                    const element = document.querySelector('#mailboxhotkey');
                                    if (element) {
                                        element.focus();
                                    }
                                }
                                catch (e) {
                                    console.error('[error]: mailCard $focus error');
                                }
                                onChecked && onChecked(!checked);
                                trackApi.track('pcMail_click_checkbox');
                            } }))) : (React.createElement(Checkbox, { style: { marginRight: showAvator ? '7px' : '0px' }, className: "avatar-checkbox", checked: checked, onClick: e => {
                            e.stopPropagation();
                            try {
                                const element = document.querySelector('#mailboxhotkey');
                                if (element) {
                                    element.focus();
                                }
                            }
                            catch (e) {
                                console.error('[error]: mailCard $focus error');
                            }
                            onChecked && onChecked(!checked);
                            trackApi.track('pcMail_click_checkbox');
                        } }))) : null,
                    showAvator && comAvatar),
                React.createElement("div", { className: "from-wrap", style: !process.env.BUILD_ISEDM ? { width: '172px' } : {} },
                    React.createElement("div", { className: "from-name-wrap" },
                        React.createElement("div", { className: "from-flag-warp" },
                            React.createElement(MailCardStateIcon, { data: data, active: true })),
                        React.createElement("div", { className: `from-name ${isRead || isDraft || isTpMail ? '' : 'font-active'}` }, comFrom),
                        React.createElement("div", { className: "from-flag-after-wrap" }, comFromFlagAfter),
                        process.env.BUILD_ISEDM || navigateVersion ? React.createElement("div", { className: "from-flag-after-wrap" }, comCustomerLabelAfter) : null))),
            !isSubordinateMail && React.createElement("div", { className: "flag-wrap" }, comSummaryExtra),
            React.createElement("div", { className: "content-warp" },
                React.createElement("div", { className: "summary-warp" },
                    comSummaryPreExtra,
                    comSummaryTask,
                    React.createElement("div", { className: `summary ${!isRead && !isTpMail && !isDraft ? 'unread-summary' : ''}` },
                        comSummary,
                        key2Heigt.desc && !!((_a = data.entry) === null || _a === void 0 ? void 0 : _a.brief) && !!((_b = data.entry) === null || _b === void 0 ? void 0 : _b.brief.trim()) ? React.createElement("span", { className: "desc-text" },
                            "\u00A0-\u00A0",
                            comDesc) : '',
                        !isSubordinateMail && comTag,
                        comApprove),
                    React.createElement("div", { className: "summary-extra-warp" },
                        eTeamType === 1 && (React.createElement("span", { style: { marginLeft: '10px', height: '16px', display: 'flex' } },
                            React.createElement(IconCard, { style: { marginLeft: '4px' }, type: "chat" }))),
                        memo && !isThread && (React.createElement(Tooltip, { title: () => {
                                return React.createElement("div", { className: "mail-card-comment-tooltip" }, memo);
                            } },
                            React.createElement(IconCard, { type: "mailComment" }))),
                        showAttachmentIcon ? (React.createElement("span", { className: "dark-svg-invert", style: { marginLeft: '7px', height: '16px', display: 'flex' } },
                            React.createElement(ReadListIcons.AttachSvg, { color: "#37435C" }))) : (React.createElement(React.Fragment, null)),
                        key2Heigt.taskDeadline ? React.createElement("div", { className: "deadline-warp" }, comTaskDeadLine) : '',
                        isDefer && !isSubordinateMail && !isThread ? React.createElement("img", { src: isOverdue ? timeoutIcon : ontimeIcon, width: "14", height: "14", style: { marginLeft: '10px' } }) : null)),
                key2Heigt.attachments ? React.createElement("div", { className: "attachments-warp long-attachments-warp" }, comAttachments) : '',
                key2Heigt.sendStatus ? React.createElement("div", { className: "status-wrap" }, comStatus) : '',
                key2Heigt.readStatus ? React.createElement("div", { className: "status-wrap" }, comSendReadStatus) : '',
                key2Heigt.suborbinateSearchFrom ? React.createElement("div", { className: "status-wrap" }, comSuborbinateFrom) : ''),
            React.createElement("div", { className: "time" }, comTime)));
    };
    const tightnessClassName = `tightness${tightness}`;
    return (React.createElement("div", { className: `mail-card-wrap ${className} ${tightnessClassName}`, style: { marginLeft: '16px' } }, renderLongCard()));
};
export const getCardHeight = (data, forceShowAttachment, showSuborbinateFrom) => {
    if (data) {
        let baseHeight = 0;
        const tightness = mailConfApi.getMailListTightness();
        if (+tightness === 1) {
            baseHeight = 16;
        }
        else if (+tightness === 2) {
            baseHeight = 8;
        }
        else if (+tightness === 3) {
            baseHeight = 0;
        }
        let sumHeight = baseHeight;
        const heightMap = getVisibleStructHeight(data, forceShowAttachment, showSuborbinateFrom);
        const keys = Object.keys(heightMap);
        if (keys.includes('from') || keys.includes('desc') || keys.includes('summary')) {
            sumHeight += heightMap.from;
        }
        sumHeight += heightMap.attachments || 0;
        sumHeight += heightMap.sendStatus || 0;
        sumHeight += heightMap.readStatus || 0;
        sumHeight += heightMap.suborbinateSearchFrom || 0;
        return sumHeight > 32 ? sumHeight : 32;
    }
    return 0;
};
export default MailCard;
